shadow$provide[355] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Strip:{enumerable:true, get:function() {
  return Strip;
}}});
var require$three = require("three");
var require$_DOT__SLASH_base_DOT_js = require("./base.js");
var require$_DOT__DOT__SLASH_geometry_SLASH_stripgeometry_DOT_js = require("../geometry/stripgeometry.js");
class Strip extends require$_DOT__SLASH_base_DOT_js.Base {
  constructor(renderer, shaders, options) {
    let f;
    super(renderer, shaders, options);
    let {uniforms, material} = options;
    const {position, color, mask, map, combine, linear, stpq} = options;
    if (uniforms == null) {
      uniforms = {};
    }
    if (material == null) {
      material = true;
    }
    const hasStyle = uniforms.styleColor != null;
    this.geometry = new require$_DOT__DOT__SLASH_geometry_SLASH_stripgeometry_DOT_js.StripGeometry({items:options.items, width:options.width, height:options.height, depth:options.depth,});
    this._adopt(uniforms);
    this._adopt(this.geometry.uniforms);
    const factory = shaders.material();
    const v = factory.vertex;
    v.pipe(this._vertexColor(color, mask));
    v.require(this._vertexPosition(position, material, map, 2, stpq));
    if (!material) {
      v.pipe("mesh.position", this.uniforms);
    }
    if (material) {
      v.pipe("strip.position.normal", this.uniforms);
    }
    v.pipe("project.position", this.uniforms);
    factory.fragment = f = this._fragmentColor(hasStyle, material, color, mask, map, 2, stpq, combine, linear);
    f.pipe("fragment.color", this.uniforms);
    const opts = factory.link({side:require$three.DoubleSide,});
    this.material = this._material(opts);
    const object = new require$three.Mesh(this.geometry, this.material);
    object.userData = opts;
    this._raw(object);
    this.renders = [object];
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.renders = this.geometry = this.material = null;
    return super.dispose();
  }
}

};